module.exports = __webpack_public_path__ + "img/QRCodeIMG.934d97b7.jpg";